import type { WorkItemFilters } from './types';

export interface WorkItemFilterRow {
  id: string;
  type: string;
  status: string;
  assignee_id: string | null;
  priority: string | null;
  parent_work_item_id: string | null;
}

export function applyWorkItemFilters<T extends WorkItemFilterRow>(
  rows: ReadonlyArray<T>,
  filters: WorkItemFilters
): T[] {
  return rows.filter((r) => {
    if (filters.status.length && !filters.status.includes(r.status)) return false;
    if (filters.type.length && !filters.type.includes(r.type)) return false;
    if (
      filters.assignee.length &&
      (!r.assignee_id || !filters.assignee.includes(r.assignee_id))
    )
      return false;
    if (
      filters.priority.length &&
      (!r.priority || !filters.priority.includes(r.priority))
    )
      return false;
    if (filters.sprint.length) return false;
    if (filters.epic.length) {
      const isTheEpic = r.type === 'epic' && filters.epic.includes(r.id);
      const isChild =
        r.parent_work_item_id !== null &&
        filters.epic.includes(r.parent_work_item_id);
      if (!isTheEpic && !isChild) return false;
    }
    return true;
  });
}
